module.exports = __webpack_public_path__ + "static/img/qcode.91ed94a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/download/img/qcode.png
// module id = IBoR
// module chunks = 177